import _ from 'lodash'
import clx from 'classnames'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '../../../../../../Common/NewDashboard/Chart/ToolTip'
import { numeralFormat } from '../../../../../../../../lib/renderUtil'
import styles from './CustomizedTooltip.css'

const CustomizedTooltip = props => {
  const { active, payload, label, isComparison, isExternalSession } = props
  const {
    color: mainPageViewColor,
    value: mainPageView
  } = _.get(payload, '0', {})
  const {
    color: comparisonPageViewColor,
    value: comparisonPageView
  } = _.get(payload, '1', {})
  const TOOLTIP_ITEM_TITLE = isExternalSession ? '工作階段' : '瀏覽量'

  if (active) {
    return (
      <ChartToolTip>
        <Title>
          {label}
        </Title>
        <Item className={clx({ [styles.itemName]: !isComparison })}>
          {
            isComparison &&
              <ItemIcon color={mainPageViewColor} />
          }
          {`${TOOLTIP_ITEM_TITLE} : ${numeralFormat(mainPageView, { allowZero: true })}`}
        </Item>
        {
          isComparison && (
            <Item >
              <ItemIcon color={comparisonPageViewColor} />
              {`${TOOLTIP_ITEM_TITLE} : ${numeralFormat(comparisonPageView, { allowZero: true })}`}
            </Item>
          )}
      </ChartToolTip>
    )
  }
  return null
}

export default CustomizedTooltip
